export default "__VITE_ASSET__3b76a459__"